import { computed, ref } from 'vue'
import { useDesignerStore } from '@/stores/designerStore'

export function useCanvasUnits() {
  const store = useDesignerStore()

  // uchovávame posledný validný pomer, aby sme nepadli na 0
  const lastX = ref(1)
  const lastY = ref(1)

  const mmToPxX = computed(() => {
    // Force dependency on scaleTick
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _tick = store.scaleTick

    const el = store.canvasRef
    if (!el || store.canvasSizeInMm.width === 0) return lastX.value

    const rect = el.getBoundingClientRect()
    if (rect.width > 0) {
      lastX.value = rect.width / store.canvasSizeInMm.width
    }
    return lastX.value
  })

  const mmToPxY = computed(() => {
    // Force dependency on scaleTick
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _tick = store.scaleTick

    const el = store.canvasRef
    if (!el || store.canvasSizeInMm.height === 0) return lastY.value

    const rect = el.getBoundingClientRect()
    if (rect.height > 0) {
      lastY.value = rect.height / store.canvasSizeInMm.height
    }
    return lastY.value
  })

  const mmToPx = (mm: number, axis: 'x' | 'y' = 'x') =>
    mm * (axis === 'x' ? mmToPxX.value : mmToPxY.value)

  const pxToMm = (px: number, axis: 'x' | 'y' = 'x') =>
    px / (axis === 'x' ? mmToPxX.value : mmToPxY.value)

  const ptToPx = (pt: number): number => {
    const mmPerPt = 25.4 / 72
    return mmToPx(mmPerPt * pt)
  }

  return {
    mmToPx,
    pxToMm,
    mmToPxX,
    mmToPxY,
    ptToPx,
  }
}
